module.exports = __webpack_public_path__ + "static/img/RiskScantwo.65a67e42.png";